const commonEditorCss = `
html, body {
  overflow-x: hidden;
  margin: 0;
}

.mce-content-body {
  font-size: 14px;
  line-height: 24px;
  padding: calc(3% + 16px) calc(6% + 16px);
  color: #242424;
  font-weight: 400;
}

.mce-content-body p {
  letter-spacing: 0.25px;
  color: #242424;
}

.mce-content-body li {
  letter-spacing: 0.25px;
  color: #242424;
}

.tox-pop {
  max-width: 30%;
}

*::-webkit-scrollbar {
  width: 8px;
}

*::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #e7e7e7;
  border: 1px solid #cacaca;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

*::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #363636;
}

.citation-group {
  display: inline-flex;
  gap: 4px;
  margin-top: 2px;
  pointer-events: none;
  width: fit-content;
  margin-left: 2px;
}

.citation-group-item {
  align-items: center;
  border-radius: 4px;
  color: white;
  display: flex;
  font-size: 8px;
  justify-content: center;
  padding: 0px 2px;
  pointer-events: auto;
  min-width: 12px;
  height: 12px;
}

.citation-call-sentence {
  background-color: #9DB4C0;

  &:hover {
    background-color: #426476ff;
    cursor: pointer;
  }
}

.citation-call-resource {
  background-color: #B4A5C0;

  &:hover {
    background-color: #624678ff;
    cursor: pointer;
  }
}

.citation-highlight {
  text-decoration: underline;
  text-decoration-style: dashed;
  text-decoration-thickness: 2px;
  text-underline-offset: 2px;
}

.citation-call-sentence-highlight {
  text-decoration-color: #9DB4C0;
}


.citation-call-resource-highlight {
  text-decoration-color: #B4A5C0;
}

.citation-tooltip {
  position: absolute;
  background: #333;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  pointer-events: none;
  z-index: 10000;
  max-width: 250px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  opacity: 0;
  transition: opacity 0.15s;
}

.citation-tooltip.visible {
  opacity: 1;
}

.citations-hidden .citation-group {
  display: none !important;
}

.citations-hidden .citation-highlight {
  text-decoration: none !important;
}
`

const regularStyles = `
@font-face {
  font-family: 'neue';
  src: url('assets/fonts/NeueHaasGroteskDisplayPro45Light.woff2') format('woff2');
}

@font-face {
  font-family: 'neue';
  font-style: italic;
  src: url('assets/fonts/NeueHaasGroteskDisplayPro46LightItalic.woff2') format('woff2');
}

h1 {
  font-size: 18pt;
  color: #2D2C2C;
}

h2 {
  font-size: 14pt;
}

body {
  font-family: 'neue', sans-serif;
}

.mce-content-body {
  font-size: 14px;
  line-height: 24px;
}

.mce-content-body p {
  line-height: 32px;
  font-weight: 100;
}

.mce-content-body li {
  line-height: 32px;
  font-weight: 100;
}
`

const agendaMinutesStyles = `
body {
  font-family: Verdana;
}

.mce-content-body {
  font-size: 10px;
  line-height: 1.25em;
  padding: calc(3% + 16px) calc(3% + 16px);
}
`

export function getEditorStyles(useAgenda: boolean) {
  return commonEditorCss + (useAgenda ? agendaMinutesStyles : regularStyles)
}
